// extracted by mini-css-extract-plugin
export var navbarSubLink = "J_f9 d_f9 d_f3 d_Z d_cb d_dl d_br d_bS";
export var menuLink = "J_vm d_fZ d_dz";
export var subPageLink = "J_gd d_gd";
export var burger = "J_vR";
export var sublinkSize = "J_vS";
export var linkSize = "J_vT";
export var Link = "J_sq w_sq w_rL w_r4";